let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1hxCL")).then(() => parcelRequire('cxLwp'));